import React, { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Button, Col, Row } from "reactstrap";
import { Link } from "react-router-dom";
import QrModal from "./QrModal";
import { useNavigate } from "react-router-dom";

const QRCodeGenerator = ({ url, data }) => {
  const navigate = useNavigate();
  const [pdfModal, setPdfModal] = useState(false);
  const togglePdfModal = () => setPdfModal(!pdfModal);

  console.log(data.id)
  if (!url) {
    return <p>Please provide a valid URL.</p>;
  }

  return (
    <Row
      className="d-print-none p-2"
      style={{ textAlign: "center", marginTop: "20px" }}
    >
      {/* <h5>Scan the QR Code to Open the URL</h5> */}
      <Col md={12} xs={12}>
        <h5 className="mb-3">Scan to Open URL</h5>
      </Col>
      <Col md={12} xs={12}>
        <QRCodeCanvas
          value={url} // The URL to encode
          size={200} // Size of the QR code
          bgColor="#ffffff" // Background color
          fgColor="#000000" // Foreground color
          level="H" // Error correction level
        />
      </Col>

      <Link to={url} target="_blank" className="mb-2 mt-3">
        {url}
      </Link>

      <Col xs={12} >
        <Row className="g-2">
          <Col md={4}>
            <Link to={`/qr-code/${data.id}`} className="d-grid h-100">
              <Button className="w-100 h-100">Print</Button>
            </Link>
          </Col>
          <Col md={4}>
            <Link to={`/small-qr-code/${data.id}`} className="d-grid h-100">
              <Button className="w-100 h-100">Print Small</Button>
            </Link>
          </Col>
          <Col md={4}>
            <Link to={`/print-flyer/${data.id}`} className="d-grid h-100">
              <Button className="w-100 h-100">Print Flyer</Button>
            </Link>
          </Col>
        </Row>
      </Col>

      <QrModal
        isOpen={pdfModal}
        toggle={togglePdfModal}
        url={url}
        data={data}
      />
    </Row>
  );
};

export default QRCodeGenerator;















// import React, { useState } from "react";
// import { QRCodeCanvas } from "qrcode.react";
// import { Button, Col, Row } from "reactstrap";
// import { Link } from "react-router-dom";
// import QrModal from "./QrModal";
// import { useNavigate } from "react-router-dom";

// const QRCodeGenerator = ({ url, data }) => {
//   const navigate = useNavigate();
//   const [pdfModal, setPdfModal] = useState(false);
//   const togglePdfModal = () => setPdfModal(!pdfModal);

//   console.log(data.id)
//   if (!url) {
//     return <p>Please provide a valid URL.</p>;
//   }

//   return (
//     <Row
//       className="d-print-none p-2"
//       style={{ textAlign: "center", marginTop: "20px" }}
//     >
//       {/* <h5>Scan the QR Code to Open the URL</h5> */}
//       <Col md={12} xs={12}>
//         <h5 className="mb-3">Scan to Open URL</h5>
//       </Col>
//       <Col md={12} xs={12}>
//         <QRCodeCanvas
//           value={url} // The URL to encode
//           size={200} // Size of the QR code
//           bgColor="#ffffff" // Background color
//           fgColor="#000000" // Foreground color
//           level="H" // Error correction level
//         />
//       </Col>

//       <Link to={url} target="_blank" className="mb-2 mt-3">
//         {url}
//       </Link>
//       <Col md={6} onClick={() => navigate(`/qr-code/${data.id}`)}>
//         <Button>Print</Button>
//       </Col>
//       <Col md={6} onClick={() => navigate(`/small-qr-code/${data.id}`)}>
//         <Button>Print Small</Button>
//       </Col>

//       <Col md={6} onClick={() => navigate(`/print-flyer/${data.id}`)}>
//         <Button>Print Flyer</Button>
//       </Col>

//       {/* <p style={{ marginTop: "10px" }}>{url}</p> */}

//       <QrModal
//         isOpen={pdfModal}
//         toggle={togglePdfModal}
//         url={url}
//         data={data}
//       />
//     </Row>
//   );
// };

// export default QRCodeGenerator;
